import { render } from "./SessionItem.vue?vue&type=template&id=09a8093d&scoped=true"
import script from "./SessionItem.vue?vue&type=script&lang=js"
export * from "./SessionItem.vue?vue&type=script&lang=js"

import "./SessionItem.vue?vue&type=style&index=0&id=09a8093d&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09a8093d"]])

export default __exports__